export default "__VITE_ASSET__Bj2BrO17__"